'use client';

import { c as _c } from "react/compiler-runtime";
import { useAdultShowAdModeEligibility } from '@module/helpers/adult/useAdultShowAdMode';
import useModalStore from '@module/stores/useModalStore';
import usePartnerStore from '@module/stores/usePartnerStore';
import { IcoAdult } from '@module/svg/icons';
import SwitchButton from '@pc/components/atoms/button/SwitchButton';
export default function AdultSwitchButton() {
  const $ = _c(10);
  const {
    AdultShowAdMode,
    setAdultShowAdMode
  } = usePartnerStore();
  const {
    pushModal
  } = useModalStore();
  const {
    adultToggleShow,
    isToggleActive
  } = useAdultShowAdModeEligibility();
  if (!adultToggleShow) {
    return null;
  }
  let t0;
  if ($[0] !== AdultShowAdMode || $[1] !== isToggleActive || $[2] !== setAdultShowAdMode) {
    t0 = isToggleActive && <div className="flex items-center gap-2"><IcoAdult /><SwitchButton checked={AdultShowAdMode === "on"} onChange={checked => {
        setAdultShowAdMode(checked.target.checked ? "on" : "off");
      }} /></div>;
    $[0] = AdultShowAdMode;
    $[1] = isToggleActive;
    $[2] = setAdultShowAdMode;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== isToggleActive || $[5] !== pushModal) {
    t1 = !isToggleActive && <div className="flex cursor-pointer items-center gap-2" onClick={() => pushModal({
      type: "IDENTITY_VERIFICATION_MODAL"
    })}><IcoAdult /><SwitchButton disabled={true} /></div>;
    $[4] = isToggleActive;
    $[5] = pushModal;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t0 || $[8] !== t1) {
    t2 = <div className="mr-[10px]">{t0}{t1}</div>;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}